module.exports = __webpack_public_path__ + "cff140f41d09ba1961eb5e6fd9f36331.svg";